import { html, LitElement } from 'lit-element';

import { latexToHTML } from '../headerBlocks/utils.js';

/**
 * @element response-block-math-inline
 * @prop {Object} response - Response
 */
export class ResponseBlockMathInline extends LitElement {
  static get properties() {
    return {
      response: { type: Object, attribute: false },
      correctnessGroup: { type: String, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  openModal({ name, avatar }) {
    if (this.correctnessGroup === 'unanswered') {
      return;
    }

    const content = html`<response-modal-math-inline
      .response=${this.response}
    ></response-modal-math-inline>`;

    const title = html`
      <div class="modal-response-header">
        ${avatar}
        <span class="student-name">${name || ''}</span>
      </div>
    `;

    window.dispatchEvent(
      new CustomEvent('classroom-tool-live-open-modal', {
        detail: {
          modalContent: content,
          modalType: 'response-modal-math-inline',
          modalTitle: title,
        },
      })
    );
  }

  render() {
    const { student, sessionData } = this.response || {};
    const { name, photo, isOnline } = student || {};
    const { completeAnswer } = sessionData || {};
    const online = isOnline || isOnline === undefined;
    const blockClasses =
      this.correctnessGroup && this.correctnessGroup === 'unanswered'
        ? 'block'
        : 'block expandable';

    let avatar;
    const opacityClass = !online ? 'offline-opacity' : '';
    const avatarClasses = `block-avatar ${opacityClass}`;

    if (photo) {
      avatar = html`<img class=${avatarClasses} src="${photo}" />`;
    } else {
      const initials = (name || '')
        .split(' ')
        .map(namePart => (namePart ? namePart[0] : ''));

      avatar = html`<div class=${avatarClasses}>${initials}</div>`;
    }

    return html` <div
      class=${online ? blockClasses : `${blockClasses} offline`}
      @click=${() => this.openModal({ name, avatar })}
    >
      ${avatar}
      <div class="block-details">
        <span class=${`student-name ${opacityClass}`}>${name || ''}</span>
        <math-rendering-element
          .label="${completeAnswer ? latexToHTML(completeAnswer) : ''}"
        ></math-rendering-element>
      </div>
      ${!online
        ? html`<div class="offline-label offline-opacity">offline</div>`
        : ''}
    </div>`;
  }
}

export default ResponseBlockMathInline;
